import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { parse } from 'query-string';

const Login = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    const params = parse(location.search);
    const ref = params.ref ? `?ref=${params.ref}` : '';
    loginWithRedirect({
      redirectUri: `${window.location.origin}/validar${ref}`,
      ...(params.prompt ? { prompt: `${params.prompt}` as any } : {}),
      ...(params.bpr ? { bpr: `${params.bpr}` } : {}),
    });
  }, []);

  return <div />;
};

export default Login;
